import { render, staticRenderFns } from "./_menu.vue?vue&type=template&id=854777c4&scoped=true&"
import script from "./_menu.vue?vue&type=script&lang=js&"
export * from "./_menu.vue?vue&type=script&lang=js&"
import style0 from "./_menu.vue?vue&type=style&index=0&id=854777c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "854777c4",
  null
  
)

export default component.exports